import { compose } from "redux";
import castArray from "lodash/castArray";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";

class Tabs extends PureComponent {
  render() {
    const { classes, value, children } = this.props;

    return (
      <Grid container>
        <Grid container wrap="nowrap" className={classes.root}>
          {React.Children.map(children, child => {
            return React.cloneElement(child, {
              selected:
                castArray(child.props.value).some(val => val === value) &&
                !child.props.disabled,
            });
          })}
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    overflow: "auto",
    backgroundColor: theme.palette.grey[200],
    "&::-webkit-scrollbar-track": {
      background: theme.palette.grey[200],
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.grey[400],
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[500],
    },
  },
});

export default compose(
  withRouter,
  withStyles(styles),
)(Tabs);
